module.exports = __webpack_public_path__ + "static/media/3.e1b6b623.jpg";